export default "__VITE_ASSET__DRv5lp9Q__"